import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import type { StoreItem } from '../types/get-store-items';
import { PromotionOfferCard } from './promotion-offer-card';

interface PromotionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Produtos em promoção a listar (derivados por `usePromotionalItems`). */
  items: StoreItem[];
  /** Acionado ao selecionar uma oferta; o modal é fechado em seguida. */
  onSelectItem?: (item: StoreItem) => void;
}

/**
 * Modal de Promoções: lista os produtos em oferta do estabelecimento em cards
 * de oferta ({@link PromotionOfferCard}). A responsabilidade de decidir *quando*
 * exibir (ex.: uma vez por sessão ao abrir) e de derivar a lista pertence a
 * outras camadas; aqui só apresentamos a lista recebida.
 *
 * Quando não há itens, o modal não é renderizado — evitando um diálogo vazio
 * caso seja aberto sem promoções válidas (default seguro).
 */
export function PromotionsModal({ isOpen, onClose, items, onSelectItem }: PromotionsModalProps) {
  const hasItems = Array.isArray(items) && items.length > 0;
  if (!hasItems) return null;

  const handleSelect = (item: StoreItem) => {
    onSelectItem?.(item);
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="max-w-[90vw] sm:max-w-md mx-auto max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader className="text-center space-y-1">
          <DialogTitle className="text-lg font-bold">Promoções</DialogTitle>
          <DialogDescription className="text-sm text-gray-600">
            Ofertas especiais selecionadas para você
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-1 overflow-y-auto -mx-2 px-2">
          {items.map(item => (
            <PromotionOfferCard key={item.id} item={item} onSelect={handleSelect} />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
